import React, { Component } from "react";
import SignalRService  from "./WhatsappSignalRService";
import SignalRServiceModel from "../models/SignalRServiceModel";
import { WhatsAppMessage } from '../models/superbit-api-models';


type Props = {
    updateMessages:Function;
  };
  

class WebsocketMessages extends Component<Props,Props> {
  signalRService:SignalRService;
  signalRServiceModel:  SignalRServiceModel;
  constructor(props:Props) {
    super(props);
    this.signalRService = new SignalRService();
    this.signalRServiceModel = new SignalRServiceModel(undefined);
  }

  componentDidMount() {
     // Example: Listen for incoming messages
    SignalRServiceModel.connectionServer.on("NewWhatsappMessage", (message) => {
        // 
        let waMessage: WhatsAppMessage;

        // Parse the JSON string into a JavaScript object
        const jsonObject = JSON.parse(message.replace("NEW:",""));
        
        // Create a WhatsAppMessage instance from the JavaScript object
        waMessage = WhatsAppMessage.fromJS(jsonObject);
        if( this.getUserId()==waMessage.SenderUserId){
          waMessage.IsRead = true;
        }
        //console.log("SignalR NewWhatsappMessage", waMessage);
        this.props.updateMessages('Whatsapp', waMessage);
    });

    SignalRServiceModel.connectionServer.on('NewAssignmentMessage', (message: any) =>{
      console.log("SignalR NewAssignmentMessage", message);
      this.props.updateMessages('Tasks', message);
    });

    SignalRServiceModel.connectionServer.on('NewSigningMessage', (message: any) =>{
      console.log("SignalR NewSigningMessage", message);
      this.props.updateMessages('Signings', message);
    });


    //       const callerConnection = signalR.getConnection();
  }

  sendMessage = () => {
    // Example: Send a message to the SignalR hub
    this.signalRService.connection.invoke("SendMessage", "Hello, SignalR!");
  };

  componentWillUnmount() {
    if (this.signalRService) {
      //this.signalRService.connection.stop();
    }
  }

  
  getUserId(){
    const parsedData = localStorage.getItem('loggedUser');
        if (parsedData) {
          const loggedUser = JSON.parse(parsedData)
          return loggedUser.id;
        }
        return "";
  }

  render() {
    return (
      <></>
    );
  }
}

export default WebsocketMessages;